import type { Texture } from 'three'

/** Extra clones kept across 2D/3D remounts. Unbounded unless cleared on project change. */
const textureCache = new Map<string, Texture>()

export function getObjectMeshTextureCache() {
  return textureCache
}

export function clearObjectMeshTextureCache() {
  textureCache.clear()
}
